import { getDoc, getDocs, query, where } from 'firebase/firestore'
import { refs } from '../models/base/firestore-refs'
import type { FormShortUrlDoc } from '../models/form_short_url/form-short-url.modl'

const SHORT_CODE_LENGTH = 4
const SHORT_CODE_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789'

/** 4文字の短縮コードを1つ生成する（トランザクション外で使用し、衝突時は呼び出し側で再試行すること） */
export function generateShortCode(): string {
  let result = ''
  for (let i = 0; i < SHORT_CODE_LENGTH; i++) {
    result += SHORT_CODE_CHARS.charAt(Math.floor(Math.random() * SHORT_CODE_CHARS.length))
  }
  return result
}

/**
 * 事業所フォームの短縮URLを管理するサービス。
 * コレクション form_short_urls（ドキュメントID = 4文字コード）
 */
export class FormShortUrlService {


  /**
   * 短縮コードから school_account_id と project_id を取得する（リダイレクト用）。
   */
  async getByCode(shortCode: string): Promise<{ schoolAccountId: string; projectId: string } | null> {
    if (!shortCode || shortCode.length !== SHORT_CODE_LENGTH) return null
    const ref = refs.formShortUrl(shortCode.toLowerCase())
    const snap = await getDoc(ref)
    if (!snap.exists()) return null
    const data = snap.data() as FormShortUrlDoc
    return {
      schoolAccountId: data.school_account_id,
      projectId: data.project_id,
    }
  }

  /**
   * 案件に紐づく短縮コードを取得する（フォームURL生成用）。
   */
  async getShortCode(schoolAccountId: string, projectId: string): Promise<string | null> {
    const col = refs.formShortUrls()
    const q = query(
      col,
      where('school_account_id', '==', schoolAccountId),
      where('project_id', '==', projectId),
    )
    const snapshot = await getDocs(q)
    const first = snapshot.docs[0]
    return first?.id ?? null
  }
}
